import { createRouter, createWebHistory } from 'vue-router'
import NotFound from '../views/NotFound.vue'
import Consumer from '../views/Consumer.vue'
import InfoHeader from '@/components/ConsumerInfoHeader.vue'
import InfoBox from '@/components/LeadInfoBox.vue'

function cleanPrepop (prepop) {
  Object.keys(prepop).forEach((key) => {
    if (prepop[key] === null || prepop[key] === '') {
      delete prepop[key]
    }
    if (prepop[key] && Array.isArray(prepop[key])) {
      var realVal = prepop[key].find((v) => v !== '')
      if (realVal) {
        prepop[key] = realVal
      } else {
        delete prepop[key]
      }
    }
    if (prepop[key] && prepop[key].toUpperCase() === `<${key.toUpperCase()}>`) {
      delete prepop[key]
    }
  })
  return prepop
}

const routes = [
  { path: '/:pathMatch(.*)*', name: 'NotFound', component: NotFound },
  {
    path: '/consumer/new/:portalCode',
    name: 'New Consumer',
    components: {
      default: Consumer,
      InfoHeader,
      InfoBox
    },
    props: {
      default: route => ({ portalCode: route.params.portalCode, prepop: cleanPrepop(route.query), isnew: true }),
      InfoHeader: () => ({ routeBack: false }),
      InfoBox: () => ({ allowEdit: false })
    }
  },
  {
    path: '/consumer/:consumerId/additional-information/new',
    name: 'Consumer Information',
    components: {
      default: Consumer,
      InfoHeader,
      InfoBox
    },
    props: {
      default: route => ({ consumerId: parseInt(route.params.consumerId), isnew: false }),
      InfoHeader: () => ({ routeBack: false }),
      InfoBox: () => ({ allowEdit: true })
    }
  },
  {
    path: '/consumer/:consumerId/additional-information/step2',
    name: 'Consumer Subject Select',
    components: {
      default: () => import(/* webpackChunkName: "consumer-offers" */ '../views/ConsumerOffers.vue'),
      InfoHeader,
      InfoBox
    },
    props: {
      default: route => ({ consumerId: parseInt(route.params.consumerId), subjectsSelected: false }),
      InfoHeader: () => ({ routeBack: 'additional-information/new' }),
      InfoBox: () => ({ allowEdit: false })
    }
  },
  {
    path: '/consumer/:consumerId/offers',
    name: 'Consumer Offers',
    components: {
      default: () => import(/* webpackChunkName: "consumer-offers" */ '../views/ConsumerOffers.vue'),
      InfoHeader,
      InfoBox
    },
    props: {
      default: route => ({ consumerId: parseInt(route.params.consumerId), subjectsSelected: true }),
      InfoHeader: () => ({ routeBack: 'additional-information/new' }),
      InfoBox: () => ({ allowEdit: false })
    }
  },
  {
    path: '/consumer/:consumerId/extraoffers',
    name: 'Consumer Extra Offers',
    components: {
      default: () => import(/* webpackChunkName: "consumer-extra-offers" */ '../views/ConsumerExtraOffers.vue'),
      InfoHeader,
      InfoBox
    },
    props: {
      default: route => ({ consumerId: parseInt(route.params.consumerId) }),
      InfoHeader: () => ({ routeBack: 'additional-information/new' }),
      InfoBox: () => ({ allowEdit: false })
    }
  },
  {
    path: '/consumer/:consumerId/no-offers',
    name: 'No Offers Available',
    components: {
      default: () => import(/* webpackChunkName: "no-offers" */ '../views/NoOffers.vue'),
      InfoHeader,
      InfoBox
    },
    props: {
      default: route => ({ consumerId: parseInt(route.params.consumerId) }),
      InfoHeader: () => ({ routeBack: 'additional-information/new' }),
      InfoBox: () => ({ allowEdit: false })
    }
  },
  {
    path: '/consumer/:consumerId/not-valid',
    name: 'Consumer Is Not Valid',
    components: {
      default: () => import(/* webpackChunkName: "not-valid" */ '../views/NotValid.vue'),
      InfoHeader,
      InfoBox
    },
    props: {
      default: route => ({ consumerId: parseInt(route.params.consumerId) }),
      InfoHeader,
      InfoBox: () => ({ allowEdit: false })
    }
  },
  {
    path: '/consumer/:consumerId/success',
    name: 'Consumer Success',
    components: {
      default: () => import(/* webpackChunkName: "consumer-success" */ '../views/ConsumerSuccess.vue'),
      InfoHeader,
      InfoBox
    },
    props: {
      default: true,
      InfoHeader: () => ({ routeBack: false }),
      InfoBox: () => ({ allowEdit: false })
    }
  },
  {
    path: '/consumer/invalid-portal',
    name: 'Invalid Portal',
    components: {
      default: () => import(/* webpackChunkName: "invalid-portal" */ '../views/InactivePortal.vue'),
      InfoHeader
    }
  }

]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
